export default obj => {
	obj.on("submit", e => {
		if (!confirm("Are you sure you want to disable two-factor authentication?")) {
			e.preventDefault();
		}
	});
};